import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CreateInvoiceLineFormGroup } from './create-invoice-line-form-group.interface';

export interface CreateInvoiceLineDefaults {
  salesOrderLineId: string;
  quantity: number;
  unitOfMeasureId: number | null;
  /**
   * Maximum allowed quantity for this line — typically `quantity - invoicedQuantity`,
   * since the FE no longer requires a shipment before invoicing.
   * Used to attach a Validators.max upper bound so over-invoice is caught client-side too.
   */
  maxQuantity: number;
}

@Injectable()
export class CreateInvoiceLineFormModel {
  private readonly formBuilder = inject(FormBuilder);

  public readonly fieldNames = {
    salesOrderLineId: 'salesOrderLineId',
    quantity: 'quantity',
    unitOfMeasureId: 'unitOfMeasureId',
  } as const;

  public buildFormGroup(defaults: CreateInvoiceLineDefaults): FormGroup<CreateInvoiceLineFormGroup> {
    return CreateInvoiceLineFormModel.buildFormGroup(this.formBuilder, defaults);
  }

  public static buildFormGroup(
    formBuilder: FormBuilder,
    defaults: CreateInvoiceLineDefaults,
  ): FormGroup<CreateInvoiceLineFormGroup> {
    return formBuilder.group<CreateInvoiceLineFormGroup>({
      salesOrderLineId: new FormControl<string | null>(defaults.salesOrderLineId, {
        validators: [Validators.required],
      }),
      quantity: new FormControl<number | null>(defaults.quantity, {
        validators: [
          Validators.required,
          Validators.min(0.0001),
          Validators.max(defaults.maxQuantity),
        ],
      }),
      unitOfMeasureId: new FormControl<number | null>(defaults.unitOfMeasureId, {
        validators: [Validators.required],
      }),
    });
  }
}
